import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { contabilidadService } from '../services/contabilidadService';
import { KPIS_QUERY_KEY } from './useKpis';
import { CAJAS_QUERY_KEY } from './useCajas';
import { MOVIMIENTOS_QUERY_KEY } from './useMovimientos';
import { CHART_QUERY_KEY } from './useChartData';
import type { EgresoPendiente, PagoPayload } from '../types';

export const EGRESOS_PENDIENTES_QUERY_KEY = ['contabilidad', 'egresos-pendientes'] as const;

export function useEgresosPendientes() {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery<EgresoPendiente[]>({
    queryKey: EGRESOS_PENDIENTES_QUERY_KEY,
    queryFn: () => contabilidadService.listEgresosPendientes(),
    staleTime: 0,
  });

  const pagarMutation = useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: PagoPayload }) =>
      contabilidadService.pagarEgreso(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: EGRESOS_PENDIENTES_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: KPIS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: CAJAS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: MOVIMIENTOS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: CHART_QUERY_KEY });
    },
  });

  return {
    egresosPendientes: data ?? [],
    isLoading,
    error,
    pagarEgreso: pagarMutation.mutateAsync,
    isPagando: pagarMutation.isPending,
  };
}
